<template>
	<div class="swiper-container swiper-container-video">
		<div class="swiper-wrapper">
			<div class="swiper-slide" @click="toDetail(item)"  v-for="item in list" :key="item.id">
				<ul class="video-list">
					<li>
						<div class="swiper-item">
							<div class="video-pic">
								<img :src="item.picUrl"/>
								<div class="video-cover">
									<img src="@/assets/icon_play.png"/>
								</div>
							</div>
							<div class="video-txt">
								<div class="list-title">
									{{item.title}}
								</div>
								<div class="list-desc">
									{{item.introduction}}
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="swiper-pagination"></div>
	</div>
</template>

<script>
	export default {
		name: 'VideoHome',
		props: {
			list: {
				type: Array,
				value: []
			}
		},
		created(){
			setTimeout(res=>{
				this.initSwiper()
			},300)
		},
		methods: {
			initSwiper(){
				new Swiper(".swiper-container-video", {
					autoplay: false,
					// 轮播效果,默认为平滑轮播
					effect: "slide",
					pagination: '.swiper-pagination',
					paginationClickable :true,
					slidesPerView: 3,
					slidesPerGroup: 3
				})
			},
			toDetail(item){
				this.$emit('toDetail', {
					id: item.id,
					columnId: item.columnId
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.video-list{
		display: flex;
		flex-wrap: nowrap;
		padding-bottom: 30px;
		li {
			width: 400px;
			padding: 10px;
			box-sizing: border-box;
			cursor: pointer;
			.swiper-item{
				width: 380px;
				height: 350px;
				margin-right: 20px;
				background: #fff;
				border-radius: 5px;
				overflow: hidden;
			}
			.swiper-item:hover{
				box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
				.video-cover{
					display:block!important;
					position:absolute;
					top:0;
					right:0;
					background:rgba(0,23,48,.37);
					width:380px;
					height:214px;
					display: flex;
					justify-content: center;
					align-items: center;
					img{
						width: 50px; height: 50px;
						display: block;
						margin: 80px auto;
						font-size: 40px;
					}
				}
			}
		}
		.video-pic{
			position: relative;
			width: 380px;
			height: 214px;
			line-height: 40px;
			font-weight: 500;
			font-size: 16px;
			color: #1075e7;
			letter-spacing: 1.78px;
			img {
				width: 380px;
				height: 214px;
			}
			.video-cover{
				display: none;
			}
		}
		.video-txt{
			height: 100px;
			margin: 16px 24px 0;
			color: #423f3f;
			line-height: 24px;
			.list-title {
				margin-bottom: 12px;
				font-weight: 500;
				line-height: 25px;
				font-size: 18px;
				letter-spacing: 1.29px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
			}
			.list-desc {
				max-width: 350px;
				font-weight: 400;
				font-size: 14px;
				letter-spacing: 1px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				vertical-align: text-top;
			}
		}
	}
</style>
